export const LIMIT_FIELD_PRECISION = 2
export const QUANTITY_FIELD_PRECISION = 5
